export const initialValues = {
  teamUsers: 5,
};

export const MANAGE_PLAN_PAYPAL_LINK =
  'https://support.yet-another-mail-merge.com/hc/en-us/sections/360004584799-Manage-your-licenses-purchased-with-Paypal-account-or-by-card-via-Paypal';
